import React, {useState, useEffect} from 'react'
import styles from './styles.css'
import Dot from 'react-icons/lib/fa/dot-circle-o'
import Refresh from 'react-icons/lib/md/refresh'

export default function Connection(props) {
  const [connection, setConnection] = useState('Disconnected')

  const pusher = global.pusher

  const setConnected = () => setConnection('Connected')
  const setDisconnected = () => setConnection('Disconnected')

  const bindConnection = () => {
    pusher.connection.bind('connected', setConnected, 'react')
  }

  const bindDisconnection = () => {
    pusher.connection.bind('disconnected', setDisconnected, 'react')
  }

  const unbindConnection = () => {
    pusher.connection.unbind('connected', null, 'react')
  }

  const unbindDisconnection = () => {
    pusher.connection.unbind('disconnected', null, 'react')
  }

  useEffect(() => {
    if (pusher) {
      bindConnection()
      bindDisconnection()
    }

    return () => {
      if (pusher) {
        unbindConnection()
        unbindDisconnection()
      }
    }
  })

  const renderMessage = () => {
    if (connection === 'Connected') {
      return (
        <div className={styles.message}>
          <Dot /> <span>Live On</span>
        </div>
      )
    }
    return (
      <div className={styles.message}>
        <Refresh /> <span>Reconectar</span>
      </div>
    )
  }

  if(isMobile()) return <span />
  if (!global.pusher) return <span />

  return (
    <div
      onClick={() => (connection === 'Connected' ? pusher.disconnect() : pusher.connect())}
      className={connection === 'Connected' ? styles.connected : styles.disconnected}>
      {renderMessage()}
    </div>
  )
}

function isMobile () {
  return window.innerWidth < 800
}



// WEBPACK FOOTER //
// ./src/App/Pages/Exchange/Layout/Pusher/Connection.js